export default "__VITE_ASSET__DC15Jt0g__"